export default function ContentSelect({ label, children, ...props }) {
  return <span className="content-select">
    <span className="content-select-label" aria-hidden="true">{label}</span>
    <select className="input" {...props}>{children}</select>
  </span>
}
